import { SelectOne as UseCaseReduxSelectOne } from '~/domain/usecases/clinicalDocs/redux';
import { ReduxSelectOne } from '~/data/store/reducer/clinicalDocs/usecases';

export const makeReduxSelectOne = (): UseCaseReduxSelectOne =>
  new ReduxSelectOne();
